/*  ========================================================================
    # Sections - Values Slider
    ========================================================================  */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import RoundedCornerImage from '../../components/RoundedCornerImage';
import bem from '../../utils/bem';
import LazyImage from '../../components/LazyImage';
import LazySource from '../../components/LazySource';
import tailwindConfig from '../../../../tailwind.config';
import useTranslation from '../../hooks/useTranslation';
import useGetParams from '../../hooks/useGetParams';
import useHistoryValues from '../../hooks/useHistoryValues';

const Donations = ({
  content,
  titleFirst,
  donationOptions,
  info,
  titleSecond,
  accountOwner,
  iban,
  paypalUrl
}) => {
  const [pickedOption, setPickedOption] = useState(null);
  const [paypal, setPaypal] = useState(true);
  const [transfer, setTransfer] = useState(false);
  const [paypalAmount, setPaypalAmount] = useState('');
  const __ = useTranslation();
  const paypalLogo =
    'data:image/svg+xml;base64,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';
  const getParams = useGetParams();

  const pushNewValues = useHistoryValues({
    ['project']: 0
  });

  const pickOption = (index, param) => {
    if (pickedOption === index) {
      setPickedOption(null);
      pushNewValues({ ['project']: null });
    } else {
      setPickedOption(index);
      pushNewValues({ ['project']: param });
    }
  };

  const pickPaypal = () => {
    setPaypal(true);
    setTransfer(false);
  };

  const pickTransfer = () => {
    setPaypal(false);
    setTransfer(true);
  };

  const purpose = index => {
    if (index !== null) {
      return donationOptions[index].option === 'custom'
        ? donationOptions[index].title
        : donationOptions[index].project.title;
    } else return '';
  };

  const qrCode = index => {
    if (index !== null) return donationOptions[index].qr_code;
    return donationOptions[0].qr_code;
  };

  const handleInputChange = event => {
    setPaypalAmount(event.target.value);
  };

  const paypalFilled = () => {
    if (paypalAmount !== '') return true;
    else return false;
  };

  useEffect(() => {
    if (getParams['project']) {
      // project params are set so find the corresponding project
      donationOptions.map((entry, key) => {
        if (entry.option === 'project' && String(entry.project.ID) === getParams['project']) {
          pickOption(key, entry.project.ID);
        } else if (entry.option === 'custom' && entry.title === getParams['project']) {
          pickOption(key, entry.title);
        }
      });
    }
  }, []);

  return (
    <>
      <div className='tw-w-8/12 tw-ml-[calc(2/12*100%)]'>
        <div className='s-donations__content' dangerouslySetInnerHTML={{ __html: content }}></div>
      </div>
      <div className='tw-w-full'>
        <div className='s-donations__first-step'>
          <div className='s-donations__first-step-title-wrapper'>
            <div
              className={bem('s-donations', 'first-step-title-number', {
                picked: pickedOption !== null
              })}
            >
              1
            </div>
            <div
              className='s-donations__first-step-title'
              dangerouslySetInnerHTML={{ __html: titleFirst }}
            ></div>
          </div>
          <div
            className={bem('s-donations', 'first-step-content', { picked: pickedOption !== null })}
          >
            {donationOptions &&
              donationOptions.map((entry, index) => (
                <button
                  key={`${entry.title}-${index}`}
                  className={bem('s-donations', 'first-step-element', {
                    picked: pickedOption === index
                  })}
                  onClick={() =>
                    pickOption(index, entry.option === 'custom' ? entry.title : entry.project.ID)
                  }
                >
                  <RoundedCornerImage
                    image={entry.option === 'custom' ? entry.image : entry.project.image}
                    additionalClasses={'s-donations__first-step-element-image'}
                    cutout='small'
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: entry.option === 'custom' ? entry.title : entry.project.title
                    }}
                  ></div>
                </button>
              ))}
          </div>
          {info && (
            <div className='s-donations__info' dangerouslySetInnerHTML={{ __html: info }}></div>
          )}
        </div>
        <div className='s-donations__second-step'>
          <div className='s-donations__second-step-title-wrapper'>
            <div
              className={bem('s-donations', 'second-step-title-number', {
                picked: pickedOption !== null
              })}
            >
              2
            </div>
            <div
              className='s-donations__second-step-title'
              dangerouslySetInnerHTML={{ __html: titleSecond }}
            ></div>
          </div>
          <div
            className={bem('s-donations', 'second-step-content', { active: pickedOption !== null })}
          >
            <div className='s-donations__second-step-content-wrapper'>
              <div className='s-donations__second-step-donate-options'>
                <div
                  className='s-donations__second-step-donate-options-paypal'
                  onClick={() => pickPaypal()}
                >
                  <div
                    className={bem('s-donations', 'second-step-radio-button', { active: paypal })}
                  ></div>
                  <div
                    className={bem('s-donations', 'second-step-donate-options-title', {
                      active: paypal
                    })}
                  >
                    {__('s-donations-paypal')}
                  </div>
                  <picture className='s-donations__second-step-donate-options-logo'>
                    <img src={paypalLogo} alt='paypal' />
                  </picture>
                </div>
                <div
                  className='s-donations__second-step-donate-options-transfer'
                  onClick={() => pickTransfer()}
                >
                  <div
                    className={bem('s-donations', 'second-step-radio-button', { active: transfer })}
                  ></div>
                  <div
                    className={bem('s-donations', 'second-step-donate-options-title', {
                      active: transfer
                    })}
                  >
                    {__('s-donations-transfer')}
                  </div>
                </div>
              </div>
              {/* Paypal */}
              {paypal && (
                <div className='s-donations__paypal'>
                  <div className='s-donations__paypal-title'>{__('s-donations-send-paypal')} </div>
                  <div className='s-donations__paypal-wrapper'>
                    <div className='s-donations__paypal-input-wrapper'>
                      <div className='s-donations__paypal-amount'>{__('s-donations-amount')}</div>
                      <div className='s-donations__paypal-input-container'>
                        <input
                          className='s-donations__paypal-input'
                          placeholder={__('s-donations-amount')}
                          type='number'
                          onChange={event => handleInputChange(event)}
                        />
                        <div
                          className={bem('s-donations', 'paypal-euro', { active: paypalFilled() })}
                        >
                          €
                        </div>
                      </div>
                    </div>
                    <a
                      href={`${paypalUrl}/${paypalAmount}`}
                      className='s-donations__paypal-send c-button'
                      target='_blank'
                      rel='noreferrer'
                    >
                      {__('s-donations-send-now')}
                    </a>
                  </div>
                </div>
              )}
              {/* Transfer */}
              {transfer && (
                <div className='s-donations__transfer'>
                  <div className='s-donations__transfer-title'>
                    {__('s-donations-send-transfer')}
                  </div>
                  <div className='s-donations__transfer-options'>
                    <div className='s-donations__transfer-qr'>
                      <LazyImage
                        figureClass={'s-donations__transfer-qr-code'}
                        defaultUrl={qrCode(pickedOption).sizes['medium_large']}
                        alt={qrCode(pickedOption).alt}
                        placeholderUrl={qrCode(pickedOption).sizes['placeholder']}
                        dataOffset={0}
                      >
                        <LazySource
                          srcSet={qrCode(pickedOption).large}
                          mediaMin={tailwindConfig.theme.screens.md}
                        />
                        <LazySource
                          srcSet={qrCode(pickedOption).medium_large}
                          mediaMin={tailwindConfig.theme.screens.sm}
                        />
                      </LazyImage>
                      <div className='s-donations__transfer-qr-text'>
                        Scannen Sie den QR-Code in Ihrer Banking-App
                      </div>
                    </div>
                    <div className={bem('s-donations', 'transfer-separator', { top: true })}></div>
                    <span className='s-donations__transfer-or'>oder</span>
                    <div className={bem('s-donations', 'transfer-separator', { bot: true })}></div>
                    <div className='s-donations__transfer-bank'>
                      <span className='s-donations__transfer-bank-title'>Kontoinhaber</span>
                      <span
                        className='s-donations__transfer-bank-subtitle'
                        dangerouslySetInnerHTML={{ __html: accountOwner }}
                      ></span>
                      <span className='s-donations__transfer-bank-title'>IBAN</span>
                      <span
                        className='s-donations__transfer-bank-subtitle'
                        dangerouslySetInnerHTML={{ __html: iban }}
                      ></span>
                      <span className='s-donations__transfer-bank-title'>Verwendungszweck</span>
                      <span
                        className='s-donations__transfer-bank-subtitle'
                        dangerouslySetInnerHTML={{
                          __html: purpose(pickedOption)
                        }}
                      ></span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Donations.propTypes = {
  content: PropTypes.string,
  titleFirst: PropTypes.string,
  donationOptions: PropTypes.array,
  info: PropTypes.string,
  titleSecond: PropTypes.string,
  accountOwner: PropTypes.string,
  iban: PropTypes.string,
  paypalUrl: PropTypes.string
};

export default Donations;
